module.exports = __webpack_public_path__ + "img/handbook_popup_envelop.b6accc30.png";